import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import MapSettingsTab from '../components/settings/MapSettingsTab'
import AccountTab from '../components/settings/AccountTab'
import CoordinateToolsTab from '../components/settings/CoordinateToolsTab'
import TemplatesTab from '../components/settings/TemplatesTab'

const TABS = [
  { id: 'map', label: 'Map' },
  { id: 'templates', label: 'Templates' },
  { id: 'account', label: 'Account' },
  { id: 'tools', label: 'Coordinate Tools' },
] as const

type TabId = (typeof TABS)[number]['id']

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState<TabId>('map')
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-xl font-semibold">Settings</h1>
          <button
            onClick={() => navigate('/')}
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            ← Back to Map
          </button>
        </div>

        {/* Tab bar */}
        <div className="flex border-b border-border mb-6">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors
                ${activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        {activeTab === 'map' && <MapSettingsTab />}
        {activeTab === 'templates' && <TemplatesTab />}
        {activeTab === 'account' && <AccountTab />}
        {activeTab === 'tools' && <CoordinateToolsTab />}
      </div>
    </div>
  )
}
